import { useMemo } from 'react';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';
import singletonRouter from 'next/router';
import { urlToSearchState, searchStateToURL } from '@monofront/business/utils';

export const useInstantSearchNextRouting = (
  baseIndexName: string,
  serverUrl: string,
) => {
  // parseURL/createURL need to read/build an object with a specific indexName,
  // but the information is not passed down from Algolia to these methods 😞
  const instantSearchRouterOptions = useMemo(
    () => ({
      parseURL: urlToSearchState(baseIndexName),
      createURL: searchStateToURL(baseIndexName),
      cleanUrlOnDispose: false,
    }),
    [baseIndexName],
  );
  const instantSearchRouting = useMemo(
    () => ({
      router: createInstantSearchRouterNext({
        singletonRouter,
        serverUrl,
        routerOptions: instantSearchRouterOptions,
      }),
    }),
    [serverUrl, instantSearchRouterOptions],
  );

  return instantSearchRouting;
};
